module.exports = __webpack_public_path__ + "static/media/shiny_fluent.5a82bf94.jpg";